import usePageSeo from "../../hooks/usePageSeo";

const PageSeo = ({ seo }) => {
  usePageSeo(seo);
  return null;
};

export default PageSeo;
